import React from 'react';
import { InputNumber, Row, Col } from 'antd';

import { FormItem } from 'utils';
import { GroupSelect } from 'components/blocks/Group';


const MainFieldSet = (props) => {
  return (
    <Row gutter={32}>
      <Col span={24}>
        <div className="form-block">
          <GroupSelect name="recommended_group" label="Рекомендуемая группа" required={true} multiple={false}/>

          <FormItem {...props} name="sort" label="Сортировка" required={true}>
            <InputNumber size="large" />
          </FormItem>
        </div>
      </Col>
    </Row>
  );
};

export default MainFieldSet;
